// Coucou global utilities — ported from webflow-export/js/global.js
// Smootify / FreeProduct logic removed — Horizon native cart used instead
// Requires GSAP + ScrollTrigger (loaded via snippets/gsap-scripts.liquid)

// ── Parallax ─────────────────────────────────────────────────────────────────
const initParallax = () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  if (!document.querySelector('.parallax-parent')) return;

  const mm = gsap.matchMedia();

  mm.add('(min-width: 992px)', () => {
    document.querySelectorAll('.parallax-parent').forEach((parent) => {
      const img = parent.querySelector('.parallax');
      if (!img) return;
      gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: parent,
          start: 'clamp(top bottom)',
          end: 'bottom top',
          scrub: true,
        },
      }).to(img, { yPercent: 18 });
    });
  });

  mm.add('(max-width: 991px)', () => {
    document.querySelectorAll('.parallax-parent').forEach((parent) => {
      const img = parent.querySelector('.parallax');
      if (img) gsap.set(img, { clearProps: 'all' });
    });
  });
};

// ── Newsletter popup (cookie-gated, 7s delay for first-time visitors) ────────
const initPopupLogic = () => {
  const popup = document.querySelector('.newsletter-popup_component');
  if (!popup) return;

  const setCookie = (name, value, days) => {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
  };

  const getCookie = (name) => {
    const eq = name + '=';
    for (const part of document.cookie.split(';')) {
      const c = part.trimStart();
      if (c.startsWith(eq)) return c.substring(eq.length);
    }
    return null;
  };

  const openPopup = () => popup.classList.add('is--open');
  const closePopup = () => {
    popup.classList.remove('is--open');
    setCookie('popup-first-time', 'true', 7);
  };

  document.querySelector('.newsletter-popup_trigger')
    ?.addEventListener('click', openPopup);

  document.querySelectorAll(
    '.newsletter-popup_overlay, .newsletter-popup_component .closing-form'
  ).forEach((el) => el.addEventListener('click', closePopup));

  if (getCookie('popup-first-time') !== 'true') {
    setTimeout(openPopup, 7000);
  }
};

// ── General Swiper for .slider_component elements ─────────────────────────────
const initSwiper = () => {
  if (!window.Swiper) return;

  document.querySelectorAll('.slider_component').forEach((component) => {
    if (component.hasAttribute('data-slider')) return;
    component.setAttribute('data-slider', '');

    const sliderEl = component.querySelector('.slider_wrap');
    if (!sliderEl) return;

    const removeEmptySlides = () => {
      const empty = sliderEl.querySelectorAll('.swiper-slide.w-dyn-bind-empty');
      empty.forEach((s) => s.remove());
      return empty.length > 0;
    };

    removeEmptySlides();

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      followFinger: true,
      freeMode: false,
      slideToClickedSlide: false,
      centeredSlides: false,
      autoHeight: false,
      speed: 600,
      mousewheel: { forceToAxis: true },
      keyboard: { enabled: true, onlyInViewport: true },
      navigation: {
        nextEl: component.querySelector('.slider_button.is-next'),
        prevEl: component.querySelector('.slider_button.is-prev'),
      },
      pagination: {
        el: component.querySelector('.slider_bullet_wrap'),
        bulletActiveClass: 'is-active',
        bulletClass: 'slider_bullet_item',
        bulletElement: 'button',
        clickable: true,
      },
      scrollbar: {
        el: component.querySelector('.slider_draggable_wrap'),
        draggable: true,
        dragClass: 'slider_draggable_handle',
        snapOnRelease: true,
      },
      slideActiveClass: 'is-active',
      slideDuplicateActiveClass: 'is-active',
    });

    // Poll for empty CMS slides removed after late-loading content
    let count = 0;
    const interval = setInterval(() => {
      if (removeEmptySlides()) swiper.update();
      if (++count >= 10) clearInterval(interval);
    }, 1000);
  });
};

// ── Standout section — sun rise + rotate (ported from Webflow IX2 action-list a-3 / a-30) ──
// Desktop/tablet/small: parent translateY 15rem→-7rem, sun rotateZ 0→60deg
// Mobile portrait:      parent translateY 4rem→-4rem,  sun rotateZ 0→60deg
const initStandout = () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  const section = document.querySelector('.stand-out_wrap');
  if (!section) return;

  const visual = section.querySelector('.stand-out_visual');
  const parent = section.querySelector('.stand-out_visual-parent');
  if (!visual || !parent) return;

  const mm = gsap.matchMedia();

  mm.add('(min-width: 480px)', () => {
    gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: {
        trigger: section,
        start: 'top 70%',
        end: 'top 10%',
        scrub: 1,
      },
    })
      .fromTo(parent, { y: '15rem' }, { y: '-7rem' })
      .fromTo(visual, { rotation: 0 }, { rotation: 60 }, 0);
  });

  mm.add('(max-width: 479px)', () => {
    gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom 20%',
        scrub: 1,
      },
    })
      .fromTo(parent, { y: '4rem' }, { y: '-4rem' })
      .fromTo(visual, { rotation: 0 }, { rotation: 60 }, 0);
  });
};

// ── Init ──────────────────────────────────────────────────────────────────────
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initParallax();
    initStandout();
    initPopupLogic();
    initSwiper();
  });
} else {
  initParallax();
  initStandout();
  initPopupLogic();
  initSwiper();
}
